import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { translate } from "../../intl";
import { Container } from "./styled";

interface LoadingIndicatorProps {
  smaller?: boolean;
  testId?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  smaller = false,
  testId,
}: LoadingIndicatorProps) => (
  <Container data-testid={testId || "loadingIndicator"} smaller={smaller}>
    <FontAwesomeIcon icon={faCircleNotch} size={smaller ? "1x" : "lg"} spin />
    <span>{translate("generic.loading")}</span>
  </Container>
);